(function() {
  var EMAIL = 'Emerson@bay-story.com';
  var WHATSAPP = '18329775296';
  var isCart = window.location.pathname === '/cart';
  var isProduct = window.location.pathname.indexOf('/products/') === 0;
  var COMPANY = 'BaystorySupply';
  var LOGO_URL = 'https://www.baystorysupply.com/cdn/shop/files/Screenshot_2025-05-08_at_18.32.59.jpg?v=1746700394&width=300';

  function getCartData() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function groupByProduct(cart) {
    var products = {};
    var order = [];
    cart.items.forEach(function(item) {
      var pid = item.product_id;
      if (!products[pid]) {
        var pUrl = item.url ? item.url.split('?')[0] : '';
        products[pid] = { title: item.product_title, url: pUrl ? ('https://www.baystorysupply.com' + pUrl) : '', variants: [], totalQty: 0, totalPrice: 0 };
        order.push(pid);
      }
      products[pid].variants.push({
        name: item.variant_title || '-',
        qty: item.quantity,
        price: item.price / 100,
        linePrice: item.line_price / 100
      });
      products[pid].totalQty += item.quantity;
      products[pid].totalPrice += item.line_price / 100;
    });
    return { products: products, order: order };
  }

  /* ===== EMAIL QUOTE ===== */
  function buildEmailBody(cart) {
    var g = groupByProduct(cart);
    var nl = String.fromCharCode(10);
    var lines = [];
    lines.push('Hi BaystorySupply Team,');
    lines.push('');
    lines.push('I would like to request a quote for the following products:');
    lines.push('');
    lines.push('========================================');

    g.order.forEach(function(pid) {
      var prod = g.products[pid];
      lines.push('');
      lines.push(prod.title);
      if (prod.url) lines.push(prod.url);
      lines.push('----------------------------------------');
      prod.variants.forEach(function(v) {
        lines.push('  ' + v.name + '  |  Qty: ' + v.qty);
      });
      lines.push('  >> Style Total: ' + prod.totalQty + ' pcs');
    });

    lines.push('');
    lines.push('========================================');
    var totalItems = cart.items.reduce(function(s, i) { return s + i.quantity; }, 0);
    lines.push('TOTAL: ' + totalItems + ' pcs');
    lines.push('========================================');
    lines.push('');
    lines.push('Please let me know the pricing and lead time.');
    lines.push('');
    lines.push('Thank you!');

    return lines.join(nl);
  }

  function openEmailQuote() {
    getCartData().then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        alert('Your cart is empty.');
        return;
      }
      var today = new Date();
      var subject = encodeURIComponent('Quote Request - ' + today.toLocaleDateString('en-US'));
      var body = encodeURIComponent(buildEmailBody(cart));
      window.location.href = 'mailto:' + EMAIL + '?subject=' + subject + '&body=' + body;
    });
  }

  /* ===== WHATSAPP QUOTE ===== */
  function buildWhatsAppBody(cart) {
    var g = groupByProduct(cart);
    var nl = String.fromCharCode(10);
    var lines = [];
    lines.push('Hi BaystorySupply,');
    lines.push('');
    lines.push('I would like to request a quote:');
    lines.push('');

    g.order.forEach(function(pid) {
      var prod = g.products[pid];
      lines.push('*' + prod.title + '*');
      if (prod.url) lines.push(prod.url);
      prod.variants.forEach(function(v) {
        lines.push('  \u2022 ' + v.name + ' - Qty: ' + v.qty);
      });
      lines.push('  _Style Total: ' + prod.totalQty + ' pcs_');
      lines.push('');
    });

    var totalItems = cart.items.reduce(function(s, i) { return s + i.quantity; }, 0);
    lines.push('*TOTAL: ' + totalItems + ' pcs*');
    lines.push('');
    lines.push('Please let me know the pricing and lead time. Thank you!');

    return lines.join(nl);
  }

  function openWhatsAppQuote() {
    getCartData().then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        alert('Your cart is empty.');
        return;
      }
      var text = encodeURIComponent(buildWhatsAppBody(cart));
      window.open('https://api.whatsapp.com/send?phone=' + WHATSAPP + '&text=' + text, '_blank');
    });
  }

  /* ===== PDF DOWNLOAD ===== */
  function loadJsPDF() {
    return new Promise(function(resolve, reject) {
      if (window.jspdf) return resolve();
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = function() { resolve(); };
      s.onerror = function() { reject(new Error('Failed to load jsPDF')); };
      document.head.appendChild(s);
    });
  }

  function loadImage(url) {
    return new Promise(function(resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() {
        try {
          var c = document.createElement('canvas');
          c.width = img.naturalWidth;
          c.height = img.naturalHeight;
          c.getContext('2d').drawImage(img, 0, 0);
          resolve(c.toDataURL('image/jpeg', 0.8));
        } catch(e) { resolve(null); }
      };
      img.onerror = function() { resolve(null); };
      img.src = url;
    });
  }

  function downloadPDF() {
    return getCartData().then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        alert('Your cart is empty.');
        return;
      }
      return Promise.all([loadJsPDF(), loadImage(LOGO_URL)]).then(function(results) {
        buildPDF(cart, results[1]);
      });
    });
  }

  function buildPDF(cart, logoData) {
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({ unit: 'mm', format: 'a4' });
    var pw = 210;
    var margin = 15;
    var usable = pw - margin * 2;
    var y = margin;
    var today = new Date();

    // Header: logo left, title+date right
    var headerTop = y;
    if (logoData) {
      doc.addImage(logoData, 'JPEG', margin, y, 20, 0);
    }
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(30);
    doc.text('Product Quote', pw - margin, headerTop + 5, { align: 'right' });
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100);
    doc.text('Date: ' + today.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pw - margin, headerTop + 11, { align: 'right' });
    doc.text('Ref: Q-' + today.getTime().toString(36).toUpperCase(), pw - margin, headerTop + 16, { align: 'right' });
    y += 20;

    doc.setDrawColor(200);
    doc.setLineWidth(0.5);
    doc.line(margin, y, pw - margin, y);
    y += 8;

    var col = {
      prodL: margin + 2,
      varL: margin + 62,
      qtyC: margin + 110,
      priceR: margin + 140,
      totalR: pw - margin - 2
    };

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.setFillColor(50, 50, 50);
    doc.rect(margin, y - 4, usable, 7, 'F');
    doc.text('Product', col.prodL, y);
    doc.text('Variant', col.varL, y);
    doc.text('Qty', col.qtyC, y, { align: 'center' });
    doc.text('Unit Price', col.priceR, y, { align: 'right' });
    doc.text('Subtotal', col.totalR, y, { align: 'right' });
    y += 7;

    var g = groupByProduct(cart);
    doc.setTextColor(30);
    var stripe = false;
    doc.setFontSize(9);

    g.order.forEach(function(pid) {
      var prod = g.products[pid];
      prod.variants.forEach(function(v, vi) {
        if (y > 270) { doc.addPage(); y = margin; }
        if (stripe) {
          doc.setFillColor(246, 246, 246);
          doc.rect(margin, y - 4, usable, 6, 'F');
        }
        stripe = !stripe;
        doc.setTextColor(30);
        if (vi === 0) {
          doc.setFont('helvetica', 'bold');
          var maxW = col.varL - col.prodL - 4;
          var titleLines = doc.splitTextToSize(prod.title, maxW);
          doc.text(titleLines, col.prodL, y);
          if (titleLines.length > 1) {
            y += (titleLines.length - 1) * 4;
          }
        }
        doc.setFont('helvetica', 'normal');
        var vname = v.name.length > 20 ? v.name.substring(0, 18) + '..' : v.name;
        doc.text(vname, col.varL, y);
        doc.text(String(v.qty), col.qtyC, y, { align: 'center' });
        doc.text('$' + v.price.toFixed(2), col.priceR, y, { align: 'right' });
        doc.text('$' + v.linePrice.toFixed(2), col.totalR, y, { align: 'right' });
        y += 6;
      });
      if (prod.variants.length > 1) {
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(100);
        doc.setFontSize(8);
        doc.text('Style subtotal: ' + prod.totalQty + ' pcs', col.priceR, y, { align: 'right' });
        doc.text('$' + prod.totalPrice.toFixed(2), col.totalR, y, { align: 'right' });
        y += 4;
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(30);
      }
      doc.setDrawColor(220);
      doc.setLineWidth(0.2);
      doc.line(margin, y - 1, pw - margin, y - 1);
      y += 3;
    });

    y += 4;
    doc.setFillColor(50, 50, 50);
    doc.rect(col.priceR - 10, y - 5, col.totalR - col.priceR + 12, 8, 'F');
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.text('Total: $' + (cart.total_price / 100).toFixed(2), col.totalR, y, { align: 'right' });
    y += 8;
    doc.setTextColor(80);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    var totalItems = cart.items.reduce(function(s, i) { return s + i.quantity; }, 0);
    doc.text('Total items: ' + totalItems + ' pcs', col.totalR, y, { align: 'right' });

    y = 275;
    doc.setDrawColor(200);
    doc.line(margin, y, pw - margin, y);
    y += 4;
    doc.setFontSize(8);
    doc.setTextColor(130);
    doc.text('This is a quote request, not a confirmed order. Prices may vary based on customization and quantity.', margin, y);
    y += 4;
    doc.text('Contact: ' + EMAIL + '  |  www.baystorysupply.com', margin, y);

    var filename = 'BaystorySupply-Quote-' + today.toISOString().slice(0, 10) + '.pdf';
    doc.save(filename);
  }

  /* ===== CREATE BUTTONS ===== */
  function createButtons() {
    if (document.getElementById('quote-email-btn')) return;
    var ctas = document.querySelector('.cart__ctas');
    if (!ctas) return false;

    var wrap = document.createElement('div');
    wrap.id = 'quote-actions';
    wrap.className = 'quote-actions';

    // Label
    var label = document.createElement('div');
    label.className = 'quote-actions-label';
    label.textContent = '\uD83C\uDFF7\uFE0F For Wholesale Pricing, Contact Us';
    wrap.appendChild(label);

    // Primary: Email button
    var emailBtn = document.createElement('button');
    emailBtn.id = 'quote-email-btn';
    emailBtn.type = 'button';
    emailBtn.className = 'quote-email-button';
    emailBtn.innerHTML = '\u2709\uFE0F Email';
    emailBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openEmailQuote();
    });

    // WhatsApp button
    var waBtn = document.createElement('button');
    waBtn.id = 'quote-wa-btn';
    waBtn.type = 'button';
    waBtn.className = 'quote-wa-button';
    waBtn.innerHTML = '\u{1F4AC} WhatsApp';
    waBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openWhatsAppQuote();
    });

    // Secondary: PDF download link
    var pdfLink = document.createElement('button');
    pdfLink.id = 'quote-pdf-btn';
    pdfLink.type = 'button';
    pdfLink.className = 'quote-pdf-link';
    pdfLink.innerHTML = '\u{1F4C4} Download PDF Quote';
    pdfLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      pdfLink.disabled = true;
      pdfLink.textContent = 'Generating...';
      downloadPDF().then(function() {
        pdfLink.disabled = false;
        pdfLink.innerHTML = '\u{1F4C4} Download PDF Quote';
      }).catch(function() {
        alert('Error generating PDF.');
        pdfLink.disabled = false;
        pdfLink.innerHTML = '\u{1F4C4} Download PDF Quote';
      });
    });

    wrap.appendChild(emailBtn);
    wrap.appendChild(waBtn);
    wrap.appendChild(pdfLink);
    ctas.parentNode.insertBefore(wrap, ctas.nextSibling);
    return true;
  }

  /* ===== CART PAGE INIT ===== */
  if (isCart) {
    var cartAttempts = 0;
    function tryCreateCart() {
      if (createButtons()) return;
      cartAttempts++;
      if (cartAttempts < 30) setTimeout(tryCreateCart, 500);
    }
    tryCreateCart();

    new MutationObserver(function() {
      if (!document.getElementById('quote-email-btn') && document.querySelector('.cart__ctas')) {
        createButtons();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ===== PRODUCT PAGE ===== */
  function getProductInfo() {
    var title = '';
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    if (titleEl) title = titleEl.innerText.trim().split('\n')[0].trim();

    var variant = '';
    // Try to get selected variant from fieldsets/radios
    var checked = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
    var parts = [];
    checked.forEach(function(r) { parts.push(r.value); });
    if (parts.length > 0) {
      variant = parts.join(' / ');
    } else {
      // Try select dropdowns
      var selects = document.querySelectorAll('.product-form__input select');
      selects.forEach(function(s) { if (s.value) parts.push(s.value); });
      if (parts.length > 0) variant = parts.join(' / ');
    }

    var qty = 1;
    var qtyInput = document.querySelector('.quantity__input, input[name="quantity"]');
    if (qtyInput) qty = parseInt(qtyInput.value) || 1;

    var productUrl = 'https://www.baystorysupply.com' + window.location.pathname;

    return { title: title, variant: variant, qty: qty, url: productUrl };
  }

  function buildProductEmailBody(info) {
    var nl = String.fromCharCode(10);
    var lines = [];
    lines.push('Hi BaystorySupply Team,');
    lines.push('');
    lines.push('I am interested in the following product:');
    lines.push('');
    lines.push('Product: ' + info.title);
    lines.push('Link: ' + info.url);
    if (info.variant) lines.push('Variant: ' + info.variant);
    lines.push('Quantity: ' + info.qty);
    lines.push('');
    lines.push('Please let me know the pricing and lead time.');
    lines.push('');
    lines.push('Thank you!');
    return lines.join(nl);
  }

  function buildProductWhatsAppBody(info) {
    var nl = String.fromCharCode(10);
    var lines = [];
    lines.push('Hi BaystorySupply,');
    lines.push('');
    lines.push('I am interested in:');
    lines.push('');
    lines.push('*' + info.title + '*');
    lines.push(info.url);
    if (info.variant) lines.push('\u2022 Variant: ' + info.variant);
    lines.push('\u2022 Quantity: ' + info.qty);
    lines.push('');
    lines.push('Please let me know the pricing and lead time. Thank you!');
    return lines.join(nl);
  }

  function createProductButtons() {
    if (document.getElementById('pdp-quote-wrap')) return;
    var formButtons = document.querySelector('product-form .product-form__buttons');
    if (!formButtons) return false;

    var wrap = document.createElement('div');
    wrap.id = 'pdp-quote-wrap';
    wrap.className = 'pdp-quote-actions';

    var label = document.createElement('div');
    label.className = 'pdp-quote-label';
    label.textContent = '\uD83C\uDFF7\uFE0F For Wholesale Pricing, Contact Us';
    wrap.appendChild(label);

    var emailBtn = document.createElement('button');
    emailBtn.type = 'button';
    emailBtn.className = 'pdp-quote-btn pdp-quote-email';
    emailBtn.innerHTML = '\u2709\uFE0F Email';
    emailBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var info = getProductInfo();
      var subject = encodeURIComponent('Wholesale Inquiry - ' + info.title);
      var body = encodeURIComponent(buildProductEmailBody(info));
      window.location.href = 'mailto:' + EMAIL + '?subject=' + subject + '&body=' + body;
    });

    var waBtn = document.createElement('button');
    waBtn.type = 'button';
    waBtn.className = 'pdp-quote-btn pdp-quote-wa';
    waBtn.innerHTML = '\u{1F4AC} WhatsApp';
    waBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var info = getProductInfo();
      var text = encodeURIComponent(buildProductWhatsAppBody(info));
      window.open('https://api.whatsapp.com/send?phone=' + WHATSAPP + '&text=' + text, '_blank');
    });

    wrap.appendChild(emailBtn);
    wrap.appendChild(waBtn);

    // Insert after the product-form__buttons div
    formButtons.parentNode.insertBefore(wrap, formButtons.nextSibling);
    return true;
  }

  if (isProduct) {
    var pdpAttempts = 0;
    function tryCreatePdp() {
      if (createProductButtons()) return;
      pdpAttempts++;
      if (pdpAttempts < 30) setTimeout(tryCreatePdp, 500);
    }
    tryCreatePdp();

    new MutationObserver(function() {
      if (!document.getElementById('pdp-quote-wrap') && document.querySelector('product-form .product-form__buttons')) {
        createProductButtons();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
